import api from './interceptor';

const BASE_URL_V2 = 'api/v2/ftp-users';

export default {
  // API Version 2
  getAll: params => api.get(`${BASE_URL_V2}`, { params }),
  create: user => api.post(`${BASE_URL_V2}/`, user),
  changePassword: (userId, data) => api.put(`${BASE_URL_V2}/${userId}/change-password`, data),
  resendEmail: userId => api.post(`${BASE_URL_V2}/${userId}/resend-email`),
  delete: userId => api.delete(`${BASE_URL_V2}/${userId}`),
};
